import { RegistrationMessageResult } from './registration-message-result.enum';
import { RegistrationRequest } from './registration-request.interface';

export interface RegistrationResponse extends RegistrationRequest {
  message: RegistrationMessageResult;
  firstPayment?: number;
  offerReference?: string;
  quoteId?: string;
  tax?: number;
}
